import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Flex, Text } from '../../shared/components';
import GIOWEB2Logo from '../../../assets/img/gioweb2_logo.svg';
import LoadingLogo from '../../../assets/img/loading-gif.gif';

export default function MainPage() {
  const logo_base64 = useSelector(state => state.app.logo);
  const dispatch = useDispatch();

  // Se llama desde core.saga.js. Si actualizamos la encontramos en la cache, no hace falta llamar al servicio
  // useEffect(() => {
  //   dispatch(getLogo());
  // }, []);

  return (
    <Flex width="100%" height="100%" justifyContent="center" alignItems="center">
      <Box style={{ width: '400px' }}>
        <Flex width="400px" alignItems="center" flexDirection="column">
          <img style={{ maxHeight: '100%', maxWidth: '100%' }} src={logo_base64 ? `data:image/png;base64, ${logo_base64}` : LoadingLogo} alt="Logo" />
          <Text color="#918E87" fontSize="18" translationId="app.slogan" mt="16" />
        </Flex>
      </Box>
    </Flex>
  );
}
